import React, { memo, useEffect, useMemo, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { marketAction } from "../../store/market/market-slice";
import { stringtoDDMMYYYY } from "../../helper/common";
import { newScriptObject } from "../../Static/data";

const MarketWatchNavs = ({
  dispatch,
  useChat,
  marketWatchTableRef,
  filterServices,
  setFieldValue,
}) => {
  const [isActiveTab, setIsActiveTab] = useState("all");
  const { send } = useChat;

  useEffect(() => {
    if (!isActiveTab) return;
    dispatch(marketAction.setMarketActiveTab(isActiveTab));
    setFieldValue("exchangeName", { label: isActiveTab, value: isActiveTab });
  }, [isActiveTab, dispatch]);

  const modifyExchangesListOption = useMemo(() => {
    return filterServices?.exchanges?.exchangesListOption.length > 0
      ? filterServices?.exchanges?.exchangesListOption.slice(1)
      : [];
  }, [filterServices?.exchanges?.exchangesListOption]);

  const handleIsActiveTab = (tabName) => {
    setIsActiveTab((prev) => {
      // Unsubscribe previous tab scripts
      if (prev === "all") {
        const tokenString =
          marketWatchTableRef?.current?.marketWatchScriptsRef?.current
            .map((x) => x.ScriptToken?.toString())
            .filter(Boolean)
            .join(",");
        if (tokenString) {
          send("UnsubscribeExchangeUpdated", tokenString);
        }
      } else {
        send("UnsubscribeExchangeWise", prev);
      }

      // Clear data when switching to 'all'
      if (tabName === "all") marketWatchTableRef?.current?.setRowData([]);

      return tabName;
    });
  };

  // Effect: clear exchange script if "all" tab
  useEffect(() => {
    if (isActiveTab === "all") {
      dispatch(marketAction.setExchangeScript([]));
      setFieldValue("changeInNavs", null);
    }
  }, [isActiveTab, dispatch]);

  // Effect: run handleAddExchangeScripts on data or tab change
  useEffect(() => {
    if (
      isActiveTab !== "all" &&
      filterServices?.scriptToken?.scriptTokenListOptions?.length
    ) {
      setFieldValue("changeInNavs", true);
      handleAddExchangeScripts();
    }
  }, [isActiveTab, filterServices?.scriptToken?.scriptTokenListOptions]);

  const handleAddExchangeScripts = () => {
    const scriptList =
      filterServices?.scriptToken?.scriptTokenListOptions || [];

    dispatch(marketAction.setExchangeScript(scriptList));

    const newItems = scriptList.map((item) => {
      const newObj = newScriptObject({
        scriptToken: item?.ScriptToken,
        name: item?.Name,
        exchange: item?.ExchangeName,
        expiry: stringtoDDMMYYYY(item?.ExpiryDate),
      });

      return {
        ...newObj,
        ...item,
        _id: item?.ScriptToken,
      };
    });

    if (newItems.length > 0) {
      marketWatchTableRef?.current?.setRowData([...newItems]);
    }
  };

  return (
    <>
      {modifyExchangesListOption.length === 0 && <p>Loading Exchanges...</p>}
      {modifyExchangesListOption.length > 0 && (
        <Tabs
          variant="underline"
          activeKey={isActiveTab}
          onSelect={handleIsActiveTab}
          id="controlled-tab-example"
          className="market-tabs"
        >
          <Tab eventKey="all" title="Custom" />
          {modifyExchangesListOption.map((exch, i) => (
            <Tab
              key={i}
              eventKey={exch?.value}
              title={exch?.label}
              className="tabs-underline"
            />
          ))}
        </Tabs>
      )}
    </>
  );
};

export default memo(MarketWatchNavs);
